'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrganizationItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrganizationItem, _Component);

  function OrganizationItem() {
    (0, _classCallCheck3.default)(this, OrganizationItem);
    return (0, _possibleConstructorReturn3.default)(this, (OrganizationItem.__proto__ || (0, _getPrototypeOf2.default)(OrganizationItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrganizationItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          changeParentFilter = _props.changeParentFilter,
          destroy = _props.destroy,
          openModal = _props.openModal,
          organization = _props.organization,
          polyglot = _props.polyglot;


      var row = _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-1 result-img' },
          organization.logo && _react2.default.createElement('img', { src: organization.logo.sizes.thumbnail, width: '72', height: '72', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-11 result-info' },
          _react2.default.createElement(
            'h3',
            null,
            organization.name
          )
        )
      );

      var editorRights = (0, _can2.default)('editor', [organization]);
      var adminRights = (0, _can2.default)('admin', [organization]);
      var hasParent = !!organization.parent;

      var infoClass = 'result-info ' + (adminRights ? 'col-md-3' : 'col-md-4');
      var rowClass = hasParent ? 'col-md-8' : 'col-md-11';

      return _react2.default.createElement(
        'div',
        { className: 'row-fluid result' },
        editorRights && _react2.default.createElement(
          'a',
          {
            className: rowClass,
            onClick: openModal
          },
          row
        ),
        !editorRights && _react2.default.createElement(
          'span',
          { className: rowClass },
          row
        ),
        hasParent && _react2.default.createElement(
          'a',
          { className: infoClass, onClick: changeParentFilter },
          _react2.default.createElement(
            'span',
            null,
            polyglot.t('organizations.subOrganizationOf')
          ),
          _react2.default.createElement(
            'h4',
            null,
            organization.parent ? organization.parent.name : ''
          )
        ),
        adminRights && _react2.default.createElement('a', {
          className: 'result-delete col-md-1',
          href: '#',
          onClick: destroy.bind(this, organization.id)
        })
      );
    }
  }]);
  return OrganizationItem;
}(_react.Component), _class.propTypes = {
  changeParentFilter: _propTypes2.default.func.isRequired,
  destroy: _propTypes2.default.func.isRequired,
  openModal: _propTypes2.default.func.isRequired,
  organization: _propTypes2.default.object.isRequired,
  polyglot: _propTypes2.default.object.isRequired
}, _temp);
exports.default = OrganizationItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Organization/OrganizationItem.js
// module id = 2240
// module chunks = 0